import React, { useState, useEffect, useContext } from 'react';

// import FileSaver from "file-saver";

import { deleteDocumentsAsync, getDocumentsAsync, uploadDocumentsAsync } from 'home/view/upgrade-order/services';

import { TOAST_TYPE } from 'home/view/upgrade-order/constants';

import { CONTEXT } from 'home/view/upgrade-order/context';

import { validateFileAndGetFormData, getErrMsg } from 'home/view/upgrade-order/utils';

import upload_icon from 'assests/svg/upload_icon.svg';
import uploading_icon from 'assests/svg/uploading.svg';
import FileUploadLib from 'featureLib/FileUpload';
import { FileTypes } from 'home/view/check-feasibility/comp-generator/common-interface';

import './index.scss';

const FileUpload = ({
  containerClassname = '',
  labelClassname = '',
  onFileUploadSuccess,
  label,
  supportedLabel,
  limitLabel,
  fileSchema,
  multiple,
  type,
  defaultFiles = [],
  disabled
}) => {
  const [isUploaded, setIsUploaded] = useState(false);
  const [error, setError] = useState({ state: false, message: '' });
  const [files, setFiles] = useState([]);
  const [progressValue, setProgressValue] = useState(0);

  const appContext = useContext(CONTEXT);
  const setToastMsg = appContext?.setToastMsg;
  const kycToken = appContext?.kycToken;

  const abortController = new AbortController();

  useEffect(() => {
    if (defaultFiles.length > 0) {
      setIsUploaded(true);
      setFiles(defaultFiles);
    }
  }, [defaultFiles]);

  useEffect(() => {
    if (files && files.length > 0 && isUploaded) {
      onFileUploadSuccess('success', type, Array.from(files));
    } else {
      onFileUploadSuccess('', type, []);
    }
  }, [isUploaded]);

  const onUploadProgress = (progressEvent) => {
    const loadingPercentage = (progressEvent.loaded / progressEvent.total) * 100;
    setProgressValue(loadingPercentage - 5);
  };

  const myFileUpload = async ({ e: event, fileList, error, setFileError, setDownloadPercentage, isDropEvent }) => {
    const { isFilesValid, formData, errorMessage, filesMetaData } = validateFileAndGetFormData({ event, ...fileSchema, files, isDropEvent });

    if (isFilesValid) {
      const uploadedFiles = [...files, ...Array.from(filesMetaData)];
      setFiles(uploadedFiles);
      setError({ state: false, message: '' });
      setFileError('');

      try {
        const { res, err } = await uploadDocumentsAsync(formData, onUploadProgress, kycToken, abortController);

        if (err) {
          const errorMsg = getErrMsg(err);
          setTimeout(() => {
            setProgressValue(0);
            setDownloadPercentage(0);
          });
          setIsUploaded(false);
          setFiles([]);
          setToastMsg?.(true, errorMsg, TOAST_TYPE.ERROR);
          throw new Error(errorMsg);
        }

        if (res) {
          const { data: { success = false } = {} } = res;

          if (success) {
            setProgressValue(100);
            setIsUploaded(true);
            setTimeout(() => {
              setProgressValue(0);
              setDownloadPercentage(0);
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      setError({
        state: true,
        message: errorMessage
      });
      setFileError(errorMessage);
    }
  };

  const getUploadedFile = async (documentName, type) => {
    const payload = { documentType: fileSchema.documentType, documentName };

    try {
      const { res, err } = await getDocumentsAsync(payload, kycToken);

      if (err) {
        const errorMsg = getErrMsg(err);
        setError({
          state: true,
          message: errorMsg || 'Error while opening files'
        });
        setToastMsg?.(true, errorMsg, TOAST_TYPE.ERROR);
        throw new Error(errorMsg);
      }

      if (res) {
        const { data } = res;

        const file = new Blob([data], { type });

        // view files in new tab
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');

        // downloadfiles
        // FileSaver.saveAs(file);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onDeleteUploadedFile = async (fileName, documentName) => {
    const payload = { documentType: fileSchema.documentType, documentName };

    setError({ state: false, message: '' });

    try {
      const { res, err } = await deleteDocumentsAsync(payload, kycToken);

      if (err) {
        const errorMsg = getErrMsg(err);
        setError({
          state: true,
          message: errorMsg || 'Error while opening files'
        });
        setToastMsg?.(true, errorMsg, TOAST_TYPE.ERROR);
        throw new Error(errorMsg);
      }

      if (res) {
        const leftFiles = files.filter(({ documentName: fileDocumentName }) => fileDocumentName !== documentName);
        setFiles(leftFiles);
        if (leftFiles.length === 0) {
          setIsUploaded(false);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const renderUploadedFiles = () => {
    return files.map(({ name, size, type, documentName }, index) => {
      return (
        <div className="custom_file_content" key={name + index}>
          <a className="name_text" role="button" href onClick={getUploadedFile.bind(null, documentName, type)}>
            {name}
          </a>
          <span className="cross_icon" onClick={onDeleteUploadedFile.bind(null, name, documentName)}></span>
        </div>
      );
    });
  };

  const getListOfFiles = () => {
    return files.map(({ name }) => name).join(', ');
  };

  return (
    <React.Fragment>
      {
        <React.Fragment>
          {
            <div className={`upload_status ${containerClassname}`}>
              <FileUploadLib
                format={[FileTypes.pdf, FileTypes.jpeg, FileTypes.jpg, FileTypes.png]}
                size={1}
                onFileUpload={myFileUpload}
                abortController={abortController}
                limit={fileSchema.documentNames.length}
                files={files}
                onFileItemClick={getUploadedFile}
                onDeleteFile={onDeleteUploadedFile}
                disabled={disabled}
              />
            </div>
          }
        </React.Fragment>
      }
    </React.Fragment>
  );
};

export default FileUpload;
